import React from "react";
import Text from "../../../../../../_components/Text";
import CurrencyInput from "react-currency-input";
import {_Input} from "../../../../../../_components/Input"

import { CreateNFeContext } from "../../Context";

export default function OtherExpensesComponent(props) {
  const context = React.useContext(CreateNFeContext);

  return (
    <div>
      <Text fontSize="1.2em" color="primary">Outras Despesas acessórias</Text>

      <_Input
        data-cy-test="#nfe-issuer-other-expenses-input-value"
        type="currency"
        onChange={e =>
          context.handlers.otherExpensesValue(e.value)
        }
        value={context.nfe.other_expenses}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/OtherExpenses/index.jsx